module.exports = __webpack_public_path__ + "assets/img/202111-6W.fb5473a7.png";